/**
* All rights Reserved, Designed By www.feidai.com
* @Title: marketActivity.ts
* @Package:
* @author: 青瞳科技
* @date: 2026/03/25 15:31:16
* @version: V1.0
* @Copyright: 2019 www.feidai.com Inc. All rights reserved.
* @Belong To: 青瞳科技
* 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
*/
import { axiosAPIUrl, Parameter } from "@/api/index";

// 1.1 MA001-获取营销活动列表 getMarketingActivityList
export function getMarketingActivityList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxMarketingActivity/getMarketingActivityList",
    method: "get",
    params: parameter,
  });
}

// 1.2 MA002-创建抽奖活动/模板 createLotteryActivity
export function createLotteryActivity (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/ccxIntegratedService/ccxMarketingActivity/createLotteryActivity',
    method: 'post',
    data: parameter,
  })
}

// 1.3 MA003-获取抽奖活动详情 getLotteryActivityDtl
export function getLotteryActivityDtl (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxMarketingActivity/getLotteryActivityDtl",
    method: "get",
    params: parameter,
  });
}

// 1.4 MA004-获取活动模板列表 getActivityTemplateList
export function getActivityTemplateList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxMarketingActivity/getActivityTemplateList",
    method: "get",
    params: parameter,
  });
}

// 1.5 MA005-获取活动模板详情 getActivityTemplateDtl
export function getActivityTemplateDtl (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxMarketingActivity/getActivityTemplateDtl",
    method: "get",
    params: parameter,
  });
}

// 1.6 MA006-修改抽奖活动 modifyLotteryActivity
export function modifyLotteryActivity (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/ccxIntegratedService/ccxMarketingActivity/modifyLotteryActivity',
    method: 'post',
    data: parameter,
  })
}


// 1.10 MA010-删除活动模板 delActivityTemplate
export function delActivityTemplate (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/ccxIntegratedService/ccxMarketingActivity/delActivityTemplate',
    method: 'post',
    data: parameter,
  })
}

// 1.11 MA011-关闭活动 closeActivity
export function closeActivity (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/ccxIntegratedService/ccxMarketingActivity/closeActivity',
    method: 'post',
    data: parameter,
  })
}

// 1.12 MA012-确认活动 confirmActivity
export function confirmActivity (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/ccxIntegratedService/ccxMarketingActivity/confirmActivity',
    method: 'post',
    data: parameter,
  })
}

// 1.13 MA013-二次确认活动 confirmActivityAgain
export function confirmActivityAgain (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/ccxIntegratedService/ccxMarketingActivity/confirmActivityAgain',
    method: 'post',
    data: parameter,
  })
}

// 1.15 MA017-店铺是否开启会员 isOpenMembership
export function isOpenMembership (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/ccxIntegratedService/ccxMarketingActivity/isOpenMembership',
    method: "get",
    params: parameter,
  })
}